import { CreateTempUserResponseDto } from "@/data/dto/user/create-temp-user-response-dto";
import { UserInfoResponseDto } from "@/data/dto/user/user-info-response-dto";
import { CreateTempUserRequestPayload } from "@/data/payload/user/create-temp-user-request-payload";
import { URLList } from "@/data/url_list";
import { createLogger, withApiLogging } from "@/utils/logger/logger";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";

export class UserSource {
  private readonly logger = createLogger("UserSource");

  constructor(private readonly client: FetchApiClientMethod) {}

  async fetchWebUserInfo(): Promise<SATResult<UserInfoResponseDto, SATError>> {
    const url = URLList.USER.GET_USER_INFO;
    try {
      const data = await withApiLogging(this.logger, { method: "GET", url }, async () => {
        const response = await this.client.get(url);
        return response.data as UserInfoResponseDto;
      });
      return SATResult.success(data);
    } catch (error: unknown) {
      return SATResult.failure(errorConverter.convertError(error));
    }
  }

  async createTempUser(
    payload: CreateTempUserRequestPayload,
  ): Promise<SATResult<CreateTempUserResponseDto, SATError>> {
    const url = URLList.USER.CREATE_TEMP;
    try {
      const data = await withApiLogging(this.logger, { method: "POST", url, payload }, async () => {
        const response = await this.client.post(url, payload);
        return response.data as CreateTempUserResponseDto;
      });
      return SATResult.success(data);
    } catch (error: unknown) {
      return SATResult.failure(errorConverter.convertError(error));
    }
  }
}
